import { useIntl } from "react-intl";

import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type ScanContainerSkipConfirmationModalProps = Pick<
  YesNoModalProps,
  "onClickYes" | "onClickNo"
>;

export function ScanContainerSkipConfirmationModal({
  onClickYes,
  onClickNo,
}: ScanContainerSkipConfirmationModalProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.scan-container-skip-confirmation-modal.title",
      })}
      body={intl.formatMessage({
        id: "components.scan-container-skip-confirmation-modal.body",
      })}
      yesLabel={intl.formatMessage({
        id: "generic.actions.skip",
      })}
      noLabel={intl.formatMessage({
        id: "generic.actions.go-back",
      })}
      isGrey
    />
  );
}
